import { render } from "./CompanyManagementView.vue?vue&type=template&id=45dc8a70"
import script from "./CompanyManagementView.vue?vue&type=script&lang=js"
export * from "./CompanyManagementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__